module.exports = __webpack_public_path__ + "img/access-desktop.7342f49c.png";